import { useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router-dom";

import { RoleType } from "@/types/role";
import { SessionType } from "@/types/session";

import { useSession } from "@/hooks/server-state/use-session";
import { useActiveRoleStore } from "@/hooks/store/use-active-role-store";

const RoleDropdown = () => {
  const navigate = useNavigate();
  const { data: session } = useSession();
  const { activeRoleId, setActiveRoleId, hydrateActiveRole } =
    useActiveRoleStore();
  const [isOpen, setIsOpen] = useState(false);
  const [prevRoleId, setPrevRoleId] = useState(activeRoleId);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const roles = (session as SessionType | null)?.roles ?? [];

  // بستن دراپ‌داون در صورت کلیک خارج از آن
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // تعیین نقش پیش‌فرض بعد از لاگین (نقش اول در صورت نبود نقش فعال معتبر)
  useEffect(() => {
    if (!roles.length) return;

    const sessionActiveId = (
      session as SessionType | null
    )?.activeRoleId?.toString();
    const hasSessionActive =
      !!sessionActiveId &&
      roles.some((r) => r.id.toString() === sessionActiveId);
    const hasCurrentActive =
      !!activeRoleId && roles.some((r) => r.id.toString() === activeRoleId);

    if (hasCurrentActive) {
      setPrevRoleId(activeRoleId);
      return;
    }

    const defaultRoleId = hasSessionActive
      ? sessionActiveId!
      : roles[0].id.toString();

    hydrateActiveRole(defaultRoleId);
    setPrevRoleId(defaultRoleId);
  }, [roles, session, activeRoleId, hydrateActiveRole]);

  // رفرش صفحه وقتی activeRoleId تغییر کرد
  useEffect(() => {
    if (activeRoleId !== prevRoleId) {
      setPrevRoleId(activeRoleId);
      navigate("/dashboard", { replace: true });
    }
  }, [activeRoleId, navigate, prevRoleId]);

  //   if (!roles.length) return null;

  const handleRoleSelect = async (roleId: string) => {
    try {
      await setActiveRoleId(roleId);
      navigate("/dashboard", { replace: true });
    } catch (error) {
      console.error("Failed to change active role", error);
    } finally {
      setIsOpen(false);
    }
    // مقدار در store ذخیره می‌شود و useEffect رفرش را انجام می‌دهد
  };

  const selectedRole = activeRoleId
    ? roles.find((r) => r.id.toString() === activeRoleId)
    : null;

  return (
    <div ref={dropdownRef} className="relative me-2 lg:block">
      {/* Dropdown Trigger */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="flex h-8 cursor-pointer items-center justify-center gap-2 rounded-full border-0 bg-transparent px-3 text-white transition-all duration-200 hover:bg-white/10"
      >
        <span className="max-w-[150px] truncate text-sm font-medium">
          {selectedRole ? selectedRole.displayNameFa : "نقش"}
        </span>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute left-0 top-full z-50 mt-2 w-48 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-lg">
          <div className="py-2">
            {roles.map((role: RoleType) => (
              <div
                key={role.id}
                onClick={() => handleRoleSelect(role.id.toString())}
                className="cursor-pointer px-4 py-2 text-center text-gray-700 transition-colors hover:bg-gray-100"
              >
                {role.displayNameFa}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleDropdown;
